class WishlistButton extends HTMLElement {
    constructor() {
      super();
  
      this.button = this.querySelector("button");
      this.formId = this.dataset.formId;
      this.productId = this.dataset.productId;
      this.productTitle = this.dataset.productTitle;
      this.productUrl = this.dataset.productUrl;
      this.imageUrl = this.dataset.imageUrl;
  
      this.clickHandler = this.onClick.bind(this);
  
      if ('_swat' in window) {
        this.init(window._swat);
      } else {
        window.SwymCallbacks = window.SwymCallbacks || [];
        window.SwymCallbacks.push(this.init.bind(this));
      }
    }
  
    async init(swat) {
      this.button.classList.remove("loading");
      const wishlist = await new Promise((resolve) => {
        swat.fetch(resolve);
      });
      const isAdded = wishlist.some(({ empi }) => empi === Number(this.productId));
  
      if (isAdded) {
        this.button.classList.add("added");
      } else {
        this.button.removeAttribute('disabled');
        this.button.setAttribute("aria-disabled", "false");
        this.button.addEventListener("click", this.clickHandler);
      }
    }
  
  async onClick(event) {
    event.preventDefault();
    

    const form = document.querySelector(`[id='${this.formId}']`);

    // Check if variant is selected before proceeding
    if (!this.areRequiredVariantOptionsSelected()) {
      // Add submitted class to trigger validation UI
      document.querySelectorAll(`[id='${this.formId}'], [form='${this.formId}']`).forEach((element) => {
        element.classList.add('submitted');
      });
      form.classList.add('submitted');
      
      // Show error message
      const errorMessage = this.getVariantSelectionMessage();
      this.showErrorMessage(errorMessage);
      return;
    }

    const formData = new FormData(form);
    const variantId = Number(formData.get('id'));

    if (variantId) {
      const response = await new Promise((resolve) =>
        window._swat.addToWishList({ ...this.buildConfig(variantId) }, resolve)
      );

      this.button.classList.add("added");
      this.button.removeEventListener("click", this.clickHandler);
    }
  }

  areRequiredVariantOptionsSelected() {
    // Check if we're on a product page with variants
    if (!document.body.classList.contains('template-product')) {
      return true;
    }

    // Find variant selectors to check if options are selected
    const productInfoContainer = document.querySelector('.product__info-container');
    const variantRadios = productInfoContainer ? productInfoContainer.querySelector('variant-radios') : document.querySelector('variant-radios');
    const variantSelects = productInfoContainer ? productInfoContainer.querySelector('variant-selects') : document.querySelector('variant-selects');
    
    if (variantRadios) {
      // For radio button variant pickers - check visible fieldsets
      const fieldsets = variantRadios.querySelectorAll('fieldset:not(.hidden)');
      
      for (let fieldset of fieldsets) {
        // Check if this fieldset has any radio buttons with checked state
        const hasCheckedRadio = fieldset.querySelector('input:checked');
        if (!hasCheckedRadio) {
          return false;
        }
      }
    }
    
    if (variantSelects) {
      // For dropdown variant pickers
      const selects = variantSelects.querySelectorAll('select');
      
      for (let select of selects) {
        if (!select.value) {
          return false;
        }
      }
    }
    
    return true;
  }

  getVariantSelectionMessage() {
    // Find variant selectors to determine what options need to be selected
    const productInfoContainer = document.querySelector('.product__info-container');
    const variantRadios = productInfoContainer ? productInfoContainer.querySelector('variant-radios') : document.querySelector('variant-radios');
    const variantSelects = productInfoContainer ? productInfoContainer.querySelector('variant-selects') : document.querySelector('variant-selects');
    
    let unselectedOptions = [];
    
    if (variantRadios) {
      // For radio button variant pickers - check visible fieldsets
      const fieldsets = variantRadios.querySelectorAll('fieldset:not(.hidden)');
      
      fieldsets.forEach(fieldset => {
        const legend = fieldset.querySelector('legend span');
        const hasCheckedRadio = fieldset.querySelector('input:checked');
        
        if (!hasCheckedRadio && legend) {
          unselectedOptions.push(legend.textContent.trim());
        }
      });
    }
    
    if (variantSelects) {
      // For dropdown variant pickers
      const selects = variantSelects.querySelectorAll('select');
      
      selects.forEach(select => {
        const label = variantSelects.querySelector(`label[for="${select.id}"]`);
        
        if (!select.value && label) {
          unselectedOptions.push(label.textContent.trim());
        }
      });
    }
    
    if (unselectedOptions.length > 0) {
      return `Please select a ${unselectedOptions.join(', ')}`;
    }
    
    return 'Please select all product options';
  }

  showErrorMessage(message) {
    // Find or create error message wrapper
    const form = document.querySelector(`[id='${this.formId}']`);
    const productForm = form.closest('product-form');
    
    if (!productForm) return;
    
    let errorWrapper = productForm.querySelector('.product-form__error-message-wrapper');
    
    if (!errorWrapper) return;
    
    let errorMessage = errorWrapper.querySelector('.product-form__error-message');
    
    if (errorMessage) {
      errorMessage.textContent = message;
      errorWrapper.removeAttribute('hidden');
      
      // Auto-hide error message after 5 seconds
      setTimeout(() => {
        errorWrapper.setAttribute('hidden', '');
      }, 5000);
    }
  }
  
    buildConfig(variantId) {
      const data = this.getVariantData();
      const variant = data.find(({ id }) => id === variantId);
  
      return {
        epi: variantId,
        empi: this.productId,
        du: this.productUrl,
        dt: this.productTitle,
        iu: this.imageUrl,
        pr: variant.price / 100,
        vi: variant.title,
      };
    }
  
    getVariantData() {
      this.variantData =
        this.variantData ||
        JSON.parse(this.querySelector('[type="application/json"]').textContent);
      return this.variantData;
    }
}

customElements.define("wishlist-button", WishlistButton);